// Module
var code = "<span class=\"delete-btn\" ng-click=\"deleteBooleanLogic($parent.row)\">\n    <i class=\"icon-trash pointer\" am-tooltip=\"top center to bottom center\" title=\"Delete\"></i>\n</span>";
// Exports
module.exports = code;